import { render, staticRenderFns } from "./VFilters.vue?vue&type=template&id=0578a064&scoped=true"
import script from "./VFilters.vue?vue&type=script&lang=js"
export * from "./VFilters.vue?vue&type=script&lang=js"
import style0 from "./VFilters.vue?vue&type=style&index=0&id=0578a064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0578a064",
  null
  
)

export default component.exports